/* tslint:disable */
import {
  Contact
} from '../index';

declare var Object: any;
export interface ContactUpdateStagingInterface {
  "Contact__c"?: string;
  "sfdcId"?: string;
  "Account__c"?: string;
  "Name"?: string;
  "Account_Name__c"?: string;
  "Approved_By__c"?: string;
  "Approval_Notes__c"?: string;
  "Approved_Date_Time__c"?: Date;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  "CurrencyIsoCode"?: string;
  "Completed_By_Account__c"?: string;
  "Completed_By__c"?: string;
  "Completed_By_Name__c"?: string;
  "Completed_Date__c"?: Date;
  "Contact_City__c"?: string;
  "Contact_Country__c"?: string;
  "Contact_First_Name__c"?: string;
  "Contact_Last_Name__c"?: string;
  "Contact_Name__c"?: string;
  "Contact_Postal_Code__c"?: string;
  "Contact_Role__c"?: string;
  "Contact_State__c"?: string;
  "Contact_Street__c"?: string;
  "Contact_Title__c"?: string;
  "Gender__c"?: string;
  "Rejected_By__c"?: string;
  "Rejected_Date_Time__c"?: Date;
  "Rejection_Notes__c"?: string;
  "Mobile_Phone__c"?: string;
  "Status__c"?: string;
  "User_Type__c"?: string;
  "Work_Email__c"?: string;
  "Work_Phone__c"?: string;
  "Region__c"?: string;
  "id"?: number;
  contact?: Contact;
}

export class ContactUpdateStaging implements ContactUpdateStagingInterface {
  "Contact__c": string;
  "sfdcId": string;
  "Account__c": string;
  "Name": string;
  "Account_Name__c": string;
  "Approved_By__c": string;
  "Approval_Notes__c": string;
  "Approved_Date_Time__c": Date;
  "CreatedById": string;
  "CreatedDate": Date;
  "createdAt": Date;
  "updatedAt": Date;
  "CurrencyIsoCode": string;
  "Completed_By_Account__c": string;
  "Completed_By__c": string;
  "Completed_By_Name__c": string;
  "Completed_Date__c": Date;
  "Contact_City__c": string;
  "Contact_Country__c": string;
  "Contact_First_Name__c": string;
  "Contact_Last_Name__c": string;
  "Contact_Name__c": string;
  "Contact_Postal_Code__c": string;
  "Contact_Role__c": string;
  "Contact_State__c": string;
  "Contact_Street__c": string;
  "Contact_Title__c": string;
  "Gender__c": string;
  "Rejected_By__c": string;
  "Rejected_Date_Time__c": Date;
  "Rejection_Notes__c": string;
  "Mobile_Phone__c": string;
  "Status__c": string;
  "User_Type__c": string;
  "Work_Email__c": string;
  "Work_Phone__c": string;
  "Region__c": string;
  "id": number;
  contact: Contact;
  constructor(data?: ContactUpdateStagingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ContactUpdateStaging`.
   */
  public static getModelName() {
    return "ContactUpdateStaging";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ContactUpdateStaging for dynamic purposes.
  **/
  public static factory(data: ContactUpdateStagingInterface): ContactUpdateStaging{
    return new ContactUpdateStaging(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ContactUpdateStaging',
      plural: 'ContactUpdateStagings',
      path: 'ContactUpdateStagings',
      idName: 'id',
      properties: {
        "Contact__c": {
          name: 'Contact__c',
          type: 'string'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Account__c": {
          name: 'Account__c',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Account_Name__c": {
          name: 'Account_Name__c',
          type: 'string'
        },
        "Approved_By__c": {
          name: 'Approved_By__c',
          type: 'string'
        },
        "Approval_Notes__c": {
          name: 'Approval_Notes__c',
          type: 'string'
        },
        "Approved_Date_Time__c": {
          name: 'Approved_Date_Time__c',
          type: 'Date'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Completed_By_Account__c": {
          name: 'Completed_By_Account__c',
          type: 'string'
        },
        "Completed_By__c": {
          name: 'Completed_By__c',
          type: 'string'
        },
        "Completed_By_Name__c": {
          name: 'Completed_By_Name__c',
          type: 'string'
        },
        "Completed_Date__c": {
          name: 'Completed_Date__c',
          type: 'Date'
        },
        "Contact_City__c": {
          name: 'Contact_City__c',
          type: 'string'
        },
        "Contact_Country__c": {
          name: 'Contact_Country__c',
          type: 'string'
        },
        "Contact_First_Name__c": {
          name: 'Contact_First_Name__c',
          type: 'string'
        },
        "Contact_Last_Name__c": {
          name: 'Contact_Last_Name__c',
          type: 'string'
        },
        "Contact_Name__c": {
          name: 'Contact_Name__c',
          type: 'string'
        },
        "Contact_Postal_Code__c": {
          name: 'Contact_Postal_Code__c',
          type: 'string'
        },
        "Contact_Role__c": {
          name: 'Contact_Role__c',
          type: 'string'
        },
        "Contact_State__c": {
          name: 'Contact_State__c',
          type: 'string'
        },
        "Contact_Street__c": {
          name: 'Contact_Street__c',
          type: 'string'
        },
        "Contact_Title__c": {
          name: 'Contact_Title__c',
          type: 'string'
        },
        "Gender__c": {
          name: 'Gender__c',
          type: 'string'
        },
        "Rejected_By__c": {
          name: 'Rejected_By__c',
          type: 'string'
        },
        "Rejected_Date_Time__c": {
          name: 'Rejected_Date_Time__c',
          type: 'Date'
        },
        "Rejection_Notes__c": {
          name: 'Rejection_Notes__c',
          type: 'string'
        },
        "Mobile_Phone__c": {
          name: 'Mobile_Phone__c',
          type: 'string'
        },
        "Status__c": {
          name: 'Status__c',
          type: 'string'
        },
        "User_Type__c": {
          name: 'User_Type__c',
          type: 'string'
        },
        "Work_Email__c": {
          name: 'Work_Email__c',
          type: 'string'
        },
        "Work_Phone__c": {
          name: 'Work_Phone__c',
          type: 'string'
        },
        "Region__c": {
          name: 'Region__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        contact: {
          name: 'contact',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'Contact__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
